import { getUrlParamsFetch, urlBackend } from "@/shared";
import { erpApi } from "@/shared/axios";
import { UseFetchEnabledParams } from "@/shared/interfaces";
import { ReporteStockHistorico, ReporteStockHistoricoResp } from "@/shared/interfaces/erp/movimiento-inventario/reporte-stock-historico.interface";
import { useQuery } from "@tanstack/react-query";

const { get } = erpApi();


export const useFetchReporteActual = ({
  params, enabled = true
}: UseFetchEnabledParams<any>) => {
  return useQuery({
    queryKey: ['ubicacion-producto-simple-excel', ...Object.values(params || {})],
    queryFn: async () => {
      return await getReporteActual(params);
    },
    retry: false,
    enabled,
  });
};

export const getReporteActual = async (params?: any) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<string>(
    `${urlBackend}api/v1/ubicacion-producto-simple/excel/?${queryParams}`,
    true
  );
  return resp;
};

///* 

export const useFetchReporteHistorico = ({
  params, enabled = true
}: UseFetchEnabledParams<any>) => {
  return useQuery({
    queryKey: ['reportestockhistorico', ...Object.values(params || {})],
    queryFn: async () => {
      return await getReporteHistorico(params);
    },
    retry: false,
    enabled,
  });
};

export const getReporteHistorico = async (params?: any) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<ReporteStockHistoricoResp>(
    `${urlBackend}api/v1/reportestockhistorico/?${queryParams}`,
    true
  );
  return resp;
};


///* reporte stock historio
export const fetchAutocompleteReporteStockHistorico = async (
  searchValue: string,
  page: number,
  params: any
): Promise<{ options: ReporteStockHistorico[]; hasMore: boolean }> => {
  const query = getUrlParamsFetch({
    ...params,
    estado: true,
    codigo: searchValue,
    page,
  });

  const response = await get<ReporteStockHistoricoResp>(`${urlBackend}api/v1/reportestockhistorico/?${query}`, true);
  return {
    options: response.data.data,
    hasMore: true,
  };
};
